<template>
  <ComDialog :isShow="dialogVisible" :width="700" :title="title" alignCenter @close="handleClose">
    <div class="adb-detail">
      <el-form :model="adbData" label-position="left" :label-width="120" class="info-form">
        <el-form-item label="云机别名">
          <div class="adb-text">{{adbData.deviceName}}</div >
        </el-form-item>
          <el-form-item label="云机ID">
          <div class="adb-text">{{adbData.deviceId}}</div >
        </el-form-item>
        <el-form-item label="云机物理编号">
          <div class="adb-text">{{adbData.ctrAlias}}</div >
        </el-form-item>
        <el-form-item label="云机IP">
          <div class="adb-text">{{adbData.ctrIp}}</div >
        </el-form-item>
        <el-form-item label="云机ADB端口">
          <div  class="adb-text">{{ adbData.ctrPort }}</div >
        </el-form-item>
        <el-form-item label="ADB服务地址">
          <div  class="adb-text">{{ adbData.serviceUrl }}</div >
        </el-form-item>
        <el-form-item label="ADB服务端口号">
          <div  class="adb-text">{{ adbData.servicePort }}</div >
        </el-form-item>
        <el-form-item label="ADB账号">
          <div class="input-with-copy">
            <div  class="adb-text">{{ adbData.adbAccount }}
            </div >
          </div>
        </el-form-item>
        <el-form-item label="ADB密码">
          <div class="input-with-copy">
            <div  class="adb-text">{{ adbData.adbPassword }}
            </div >
          </div>
        </el-form-item>
        <el-form-item label="账号过期时间">
          <div  class="adb-text">{{ formattedExpireTime }}</div >
        </el-form-item>
        <el-form-item label="ADB连接示例">
          <div  class="adb-text">{{ adbData.example }}</div >
        </el-form-item>
      </el-form>
    </div>
    <div class="dialog-footer"> 
      <el-button type="primary"  @click="copyAdbData(adbData)">一键复制</el-button>
    </div>
  </ComDialog>
</template>

<script setup>
import { ref, defineExpose, computed } from "vue";
import ComDialog from "@/components/comDialog/index.vue";
import { ElMessage } from "element-plus";
import request from "@/utils/request";
import API_CONFIG from "../api.json";

const dialogVisible = ref(false);
const title = ref("ADB账号详情");
const adbData = ref({
  deviceName: "",
  deviceId: "",
  ctrAlias: "",
  ctrIp: "",
  ctrPort: 0,
  serviceUrl: "",
  servicePort: 0,
  adbAccount: "",
  adbPassword: "",
  expire: 0,
  example: ""
});

// 格式化过期时间
const formattedExpireTime = computed(() => {
  if (!adbData.value.expire) return "";
  return new Date(adbData.value.expire).toLocaleString();
});

// 复制文本到剪贴板
const copyText = (text) => {
  if (!text) {
    ElMessage.warning("没有可复制的内容");
    return;
  }
  navigator.clipboard.writeText(text).then(() => {
    ElMessage.success("复制成功");
  }).catch(() => {
    ElMessage.error("复制失败");
  });
};

// 打开对话框
const open = (data) => {
  request.post(API_CONFIG.getAdbAccount.url,{
      ctrAlias: data.code
    }
  ).then(res => {
    if (res.code == 0) {
      const responseData = res.data
      adbData.value = { 
          deviceName: data.name || "",
          deviceId: data.id || "",
          ctrAlias: data.code || "",
          ctrIp: responseData.ctrIp || "",
          ctrPort: responseData.ctrPort || 0,
          serviceUrl: responseData.serviceUrl || "",
          servicePort: responseData.servicePort || 0,
          adbAccount: responseData.adbAccount || "",
          adbPassword: responseData.adbPassword || "",
          expire: responseData.expire || 0,
          example: responseData.example || ""
      };
    } else {
      ElMessage.error(res.msg || "获取ADB账号失败");
    }
  });
  dialogVisible.value = true;
};

// 关闭对话框
const handleClose = () => {
  dialogVisible.value = false;
  adbData.value = {
    deviceName:"",
    deviceId: "",
    ctrAlias: "",
    ctrIp: "",
    ctrPort: 0,
    serviceUrl: "",
    servicePort: 0,
    adbAccount: "",
    adbPassword: "",
    expire: 0,
    example: ""
  };
};

const copyAdbData = (data) => {
  copyText(
    '云机别名: ' + data.deviceName + '\n' +
    '云机ID: ' + data.deviceId + '\n' +
    '云机IP: ' + data.ctrIp + '\n' +
    '云机ADB端口: ' + data.ctrPort + '\n' +
    'ADB服务地址: ' + data.serviceUrl + '\n' +
    'ADB服务端口号: ' + data.servicePort + '\n' +
    'ADB账号: ' + data.adbAccount + '\n' + 
    'ADB密码: ' + data.adbPassword + '\n' +
    '账号过期时间: ' + formattedExpireTime.value 
  );
}

// 暴露方法
defineExpose({
  open
});
</script>

<style lang="scss" scoped>
.adb-detail {
  .info-form {
    margin: 0;
    .el-form-item {
      margin-bottom: 16px;
    }
    .adb-text {
      width: 100%;
      padding: 4px 12px;
      min-height: 40px;
      border-radius: 4px;
      background-color: rgba($color: #000000, $alpha: .85);
      color: #fefefe;
      font-size: 14px;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .input-with-copy {
      display: flex;
      width: 100%;
      gap: 12px;
      align-items: center;
      .div  {
        flex: 1;
      }
    }
      .copy-icon {
        cursor: pointer;
        color: #fefefe;
        font-size: 14px;
        &:hover{
          color: #ffffff;
        }
      }
  }
}
.dialog-footer {
  display: flex;
  justify-content: center;
  padding-top: 20px;
}
</style>